import React from 'react';
import {Grid, Icon, Sidebar} from "semantic-ui-react";
import styled from 'styled-components';
import Legend from 'components/map/Legend';


const SideNav = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  margin-left: 0;
  margin-right: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 100%;
  background: #f5c9a3;
  transition: width 0.15s;
  flex-direction: column;
  z-index: 9995;
  overflow-y: auto;
  min-width: 90px;
`;

const IconLink = styled.span`
  font-size: 0.7rem;
  padding: 1rem;
  font-weight: 600;
  margin-bottom: 1px;
  color: #2c3e50;

  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
`

const IconContent = styled.span`
  margin: 0;
  text-align: center;
`

const NavList = styled.ul`
  list-style: none;
  margin-left: 0;
`

const NavItem = styled.li`
  
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    border-right: #c84918 solid 5px;
    cursor: pointer;
  } 
`

const SidebarWrapper = styled.div`
  background: white;
  z-index: 9999;
`

const SidebarContentWrapper = styled.div`
  padding: 15px;
`

const InfoComponent = () => (
  <SidebarContentWrapper>
    <h5>Climate Descriptors</h5>

    <p><b>Low change</b>: based on RCP4.5<br />
       <b>High change</b>: based on RCP8.5</p>

    <h5>Population change</h5>
    <p><b>Low change</b>: based on SSP2<br />
       <b>High change</b>: based on SSP4</p>

    <h5>Adaptation Descriptions</h5>

    <p>Influences the standard of protection afford by coastal, fluvial and surface water drainage physical 
      infrastructure</p>

    <p>The changes are applied based on present day standards
      <ul>
        <li>Reduced - standards reduce from today</li>
        <li>Maintain - as today</li>
        <li>Enhance - standards are enhanced compared to today</li>
      </ul>
    </p>

    <p>The standards of protection used vary according to land use, with urban areas receiving a higher standard today and, in the future, compared to rural areas.</p>

    <h5>Metrics</h5>

    <p><b>Annual Probability of flooding</b>: Considers the source of the flood hazard and shows the annual chance of exceeding a given depth. The analysis is driven by detailed hydrological analysis (CEH Wallingford) connected to a 2D hydraulic analysis (15m grid - based on MOSIAC DTM enhanced within Machine Learning approaches trained and validated on high resolution 100km2 2.5m datasets) - lead by Sayers and Partners  The standard of protection of fluvial and coastal flood defences is included (based on land use considerations) as well as drainage capacity (developed with UPM Malaysia and DID published information).</p>

    <p><b>EAD</b>: Expected Annual Damage - an integration of a full range flood return periods, taking account of the chance of flooding - including the influence of defences - and the associated damage based on the detailed land use data (developed here by Millar et al) and depth damage relationships based an integration of those published by DID and JRC.</p>

    <h5>Supporting Papers</h5>
    <p>Bell, Victoria; Rehan, Balqis; Hasan-Basri, Bakti; Houghton-Carr, Helen; Miller, James; Reynard, Nick; Sayers, Paul; Stewart, Elizabeth; Toriman, Mohd Ekhwan; Yusuf, Badronnisa; Zulkafli, Zed; Carr, Sam; Chapman, Rhian; Davies, Helen; Fatdillah, Eva; Horritt, Matt; Kabirzad, Shabir; Kaelin, Alexandra; Okeke, Tochukwu; Rameshwaran, Ponnambalam; Simpson, Mike (2021). Flood Impacts Across Scales: towards an integrated multi-scale approach for Malaysia Proceedings of the FLOODrisk 2020 - 4th European Conference on Flood Risk Management DOI: 10.3311/FloodRisk2020.9.6 </p>
      
    <p>E Fatdillah, BM Rehan, P Rameshwaran, VA Bell, Z Zulkafli, B Yusuf and P Sayers (2022) Spatial estimates of flood damage and risk are influenced by the underpinning DEM resolution: a case study in Kuala Lumpur, Malaysia.  Journal of Water 14 (14), 2208.</p>

    <h5>Machine Learning (topographic improvement)</h5>

    <p>The SRTM datasets have been refined through the application of ML randon forest and neutal network methods 
      based on high resolution training and validation data within Malaysia (Sayers and Carr in press)</p>
  </SidebarContentWrapper>
)


const DownloadComponent = () => (
  <SidebarContentWrapper>
    <h5>Download</h5>

    <p><b>Land cover datasets</b>: Kaelin, A.; Miller, J.; Rehan, B.; Sayers, P.; Stewart, E.; Houghton-Carr, H.;
     Hasan-Basri, B. (2021). A land use map of Peninsular Malaysia for the year 2018 (25m grid).
      NERC Environmental Information Data Centre. <a href="https://doi.org/10.5285/36df244e-11c8-44bc-aa9b-79427123c42c" target='_blank'>https://doi.org/10.5285/36df244e-11c8-44bc-aa9b-79427123c42c</a></p>

    <p><b>Population</b>: World population <a href='https://hub.worldpop.org/geodata/summary?id=50014)' target='_blank'>https://hub.worldpop.org/geodata/summary?id=50014)</a></p>

    <p><b>Hydrology</b>: Rameshwaran, P.; Bell, V.A.; Davies, H.N.; Brown, M.J.; Zulkafli, Z.; Rehan, B.M.; 
    Okeke, T.C. (2022). Historical (1971-2005) and projected (2006-2099) hydrological model (HMF-Malaysia) 
    estimates of monthly mean and annual maximum river flows across Peninsular Malaysia driven by CORDEX-SEA 
    projected climate data. NERC EDS Environmental Information Data Centre.  <a href='https://doi.org/10.5285/9b70bebe-189c-4ae8-9aee-1bb1db7b1ad5' target='_blank'>https://doi.org/10.5285/9b70bebe-189c-4ae8-9aee-1bb1db7b1ad5</a></p>
    
    
    <p>For all others, please <a href="http://www.sayersandpartners.co.uk/contact-us.html">Contact us - Sayers and Partners</a></p>
  </SidebarContentWrapper>


)

export default ({shapeFiles, tiffFiles}) => {

  const [sidebarContent, setSidebarVisible] = React.useState(false)

  return (
    <React.Fragment>
      <Sidebar
        visible={!!sidebarContent}
        onHide={() => setSidebarVisible(false)}
        vertical='true'
        direction='right'
        animation='overlay'
        width='wide'
        style={{background: 'white', zIndex: 9999}}
      >
        <SidebarWrapper>
          {sidebarContent === 'info' && <InfoComponent /> }
          {sidebarContent === 'library' && <SidebarContentWrapper>Hello library. Attributions live here</SidebarContentWrapper>}
          {sidebarContent === 'download' && <DownloadComponent />}
          {sidebarContent === 'key' && <SidebarContentWrapper><Legend shapeFiles={shapeFiles} tiffFiles={tiffFiles} /> </SidebarContentWrapper>}
          {sidebarContent === 'help' && <SidebarContentWrapper><a href="http://www.sayersandpartners.co.uk/contact-us.html">Contact us - Sayers and Partners</a></SidebarContentWrapper>}
        </SidebarWrapper>
      </Sidebar>
      <SideNav width={1}>
      <NavList>

        <NavItem>
          <IconLink onClick={() => setSidebarVisible('info')}>
            <IconContent>
              <span><Icon name='info' size='big' /></span>
              <span style={{display: 'block'}}>
              Info
                </span>
            </IconContent>
          </IconLink>
        </NavItem>

        <NavItem>
          <IconLink onClick={() => setSidebarVisible('download')}>
            <IconContent>
              <span><Icon name='download' size='big' /></span>
              <span style={{display: 'block'}}>
              Download
                </span>
            </IconContent>
          </IconLink>
        </NavItem>

        <NavItem>
          <IconLink onClick={() => setSidebarVisible('key')}>
            <IconContent>
              <span><Icon name='key' size='big' /></span>
              <span style={{display: 'block'}}>
              Key
                </span>
            </IconContent>
          </IconLink>
        </NavItem>


        <NavItem>
          <IconLink onClick={() => setSidebarVisible('help')}>
            <IconContent>
              <span><Icon name='help circle' size='big' /></span>
              <span style={{display: 'block'}}>
              Help
                </span>
            </IconContent>
          </IconLink>
        </NavItem>

      </NavList>
      </SideNav>




    </React.Fragment>
    )
}

export {
  SidebarWrapper,
  NavItem,
  SideNav,
  NavList,
  IconLink,
  IconContent
}